<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';

    import { Navigation } from '../../../utilities/Navigation';
    import type { JobHistoryItem } from './JobHistoryItem';
    import type { JobHistoryApp } from './JobHistoryApp';

    export let jobHistoryItem: JobHistoryItem;
    export let jobHistoryApp: JobHistoryApp;
    export let showDetails: boolean = false;
</script>

<div class="capitalize-first-letter">
    {#if jobHistoryItem.getData().event_type === 'create'}
        <div></div>
    {:else if jobHistoryItem.getNewVehicleId() === null}
        {#if jobHistoryItem.getEventChanger() !== null || showDetails}
            <span class="job-history-mark"
                >{jobHistoryItem.getEventChanger() ?? $_('undefined')}</span
            >
        {/if}
    {:else if jobHistoryItem.getTacticalPLanRuleId() !== null && jobHistoryItem.getData().event_type === 'suggest'}
        {#if jobHistoryItem.getTacticalPlanId(jobHistoryApp.tacticalPlanRules) !== null}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <span
                class="link"
                on:click={() => {
                    closeModal();
                    Navigation.navigate(
                        `/tactical-plan/${jobHistoryItem.getTacticalPlanId(jobHistoryApp.tacticalPlanRules)}`
                    );
                }}
            >
                {$_('rule')}
            </span>
        {:else}
            {$_('rule')}
        {/if}
        <span class="job-history-mark">
            {#if jobHistoryItem.getTacticalPlanRuleName(null) !== null}
                {jobHistoryItem.getTacticalPlanRuleName(null) ?? $_('undefined')}
            {:else}
                {$_('no name')}
            {/if}
        </span>
        {#if jobHistoryItem.getZoneId() !== null}
            {$_('in_zone')}
            <span class="job-history-mark">
                {#if jobHistoryItem.getZoneName(null) !== null}
                    {jobHistoryItem.getZoneName(null) ?? $_('undefined')}
                {:else}
                    {$_('no name')}
                {/if}
            </span>
        {/if}
        {#if jobHistoryItem.isTacticalPlanRuleAutoAccepted(jobHistoryApp.tacticalPlanRules)}
            ({$_('auto_confirm')})
        {/if}
        {#if jobHistoryItem.getTacticalPlanName()}
            (wg planu taktycznego: <span class="job-history-mark"
                >{jobHistoryItem.getTacticalPlanName()}</span
            >)
        {/if}
    {:else if jobHistoryItem.getEventChanger() !== null || showDetails}
        <span class="job-history-mark">{jobHistoryItem.getEventChanger() ?? $_('undefined')}</span>
    {/if}
</div>

<style>
    .job-history-mark {
        font-weight: 600;
        /*color: #1c5dc7;*/
    }
    .capitalize-first-letter {
        display: inline-block;
    }
    .capitalize-first-letter:first-letter {
        text-transform: uppercase;
    }
    .link {
        color: #1d5fc9;
        text-decoration: underline;
        cursor: pointer;
        text-align: center;
    }
    .link:hover {
        color: #1d5fc9;
        /*font-weight: 600;*/
        text-decoration: none;
    }
</style>
